import { getYear } from 'date-fns'

const MAX_NUMBER_OF_YEARS = 16

export const getYearOptions = () => {
  const currentYear = getYear(new Date())
  const yearsArray = Array.from({ length: MAX_NUMBER_OF_YEARS }, (curr, idx) => currentYear + idx)
  return yearsArray.map(year => ({ label: year, value: year }))
}
